import { render } from "./FormContact.vue?vue&type=template&id=4b796d10&scoped=true&ts=true"
import script from "./FormContact.vue?vue&type=script&lang=tss"
export * from "./FormContact.vue?vue&type=script&lang=tss"

import "./FormContact.vue?vue&type=style&index=0&id=4b796d10&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b796d10"]])

export default __exports__